






export default {
    name: 'ImageComponent',
    props: {
      url: String,
    } 
}
